(() => {
  if (window.ooohhhProductContextPanelLoaded) return;
  window.ooohhhProductContextPanelLoaded = true;

  const params = new URLSearchParams(window.location.search);
  const handle = (params.get('handle') || '').trim().toLowerCase();
  const handlePattern = /^[a-z0-9][a-z0-9-]*$/;
  const isValidHandle = handle && handlePattern.test(handle);
  const panels = document.querySelectorAll('[data-product-context-panel]');
  const analyticsRoots = document.querySelectorAll('[data-high-intent-form-page]');
  const publishedViews = new Set();

  const publishAnalyticsEvent = (eventName, payload) => {
    if (!eventName || !window.Shopify || !Shopify.analytics || typeof Shopify.analytics.publish !== 'function') {
      return false;
    }

    try {
      const result = Shopify.analytics.publish(eventName, payload);

      if (result && typeof result.catch === 'function') {
        result.catch(() => {});
      }

      return true;
    } catch (error) {
      // Analytics should never block the page or form experience.
    }

    return false;
  };

  const publishViewEvents = (product = {}) => {
    analyticsRoots.forEach((root) => {
      const eventName = root.getAttribute('data-high-intent-view-event');

      if (!eventName || publishedViews.has(eventName)) return;

      const payload = {
        form_type: root.getAttribute('data-high-intent-form-type') || '',
        locale: root.getAttribute('data-high-intent-locale') || '',
        source_page_type: root.getAttribute('data-high-intent-source-page-type') || 'page',
      };

      if (isValidHandle) payload.product_handle = handle;
      if (product.id) payload.product_id = String(product.id);

      if (publishAnalyticsEvent(eventName, payload)) {
        publishedViews.add(eventName);
      }
    });
  };

  if (!isValidHandle) {
    publishViewEvents();
    return;
  }

  const unique = (items) => [...new Set(items.filter(Boolean))];
  const root = panels[0] ? panels[0].getAttribute('data-product-context-root') || '/' : '/';
  const normalizedRoot = root.endsWith('/') ? root : `${root}/`;
  const endpoints = unique([
    `${normalizedRoot}products/${encodeURIComponent(handle)}.js`,
    `/products/${encodeURIComponent(handle)}.js`,
  ]);

  const fetchProduct = async () => {
    for (const endpoint of endpoints) {
      try {
        const response = await fetch(endpoint, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) continue;

        const product = await response.json();
        const title = (product && product.title ? product.title : '').split(' | ')[0].trim();

        if (title) {
          return {
            id: product.id,
            title,
          };
        }
      } catch (error) {
        // If a localized endpoint is unavailable, quietly try the next source-backed URL.
      }
    }

    return {};
  };

  fetchProduct().then((product) => {
    if (product.title) {
      panels.forEach((panel) => {
        const titleTarget = panel.querySelector('[data-product-context-title]');

        if (!titleTarget) return;

        titleTarget.textContent = product.title;
        panel.dataset.artworkHandle = handle;
        panel.hidden = false;
      });
    }

    publishViewEvents(product);
  });
})();
